type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const developedByLink = ''

export const developedBy = 'MarkeyThemes'

export const contactUs = ''

export const buyLink = ''

export const basePath = '/'

export const DEFAULT_PAGE_TITLE = 'Skywave Next - IT Solution & Technology HTML Landing Template'
